export const AirportsFrom = 'airports-from';
export const AirportsTo = 'airports-to';
export const Duration = 'duration';
export const Month = 'month';
